import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  list: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  sublist: { data: [], loading: false },
  logs: { data: [], loading: false },
  downloads: { data: [], loading: false },
  types: { data: [], raw: [], loading: false },
  dialog: { visible: false, loading: false, type: '' },
  confirm: { name: '', title: '', content: '', visible: false, loading: false },
  loading: false,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
